import { createModal } from '@utils/modal-util.ts';
import PickTransferRequests from '@src/transfer-request/pick-transfer-requests.vue';
import { closeLoader, openLoader } from '@utils/loader-util.ts';
import { usePickingCartComposable } from '@src/pick/picking-cart/composable/picking-cart-composable';
import apiClient, { createApiErrorModal } from '@src/api/api-client.ts';
import { ApiError } from '@src/api/api-error';
import { ref } from 'vue';

export function useTransferRequestPickComposable() {
    const { selectPickingCart } = usePickingCartComposable();

    async function loadClusters() {
        const request = apiClient.get('/be/transfer-request/pick/clusters');
        request.setCustomErrorHttpCodes(400);

        try {
            openLoader();
            const response = (await request).data;
            closeLoader();

            return response;
        } catch (e: any) {
            closeLoader();
            if (!(e instanceof ApiError)) {
                throw e;
            }
            if (e.code === 'NO_CURRENT_PICKING_CART') {
                await selectPickingCart();
                return loadClusters();
            }

            await createApiErrorModal(e);
            throw e;
        }
    }

    async function createPickModal() {
        const clusters = await loadClusters();
        if (clusters.length > 0) {
            await createModal(false, PickTransferRequests, 'done', null, null, '2');
        }
    }

    const toPick = ref<number>(0);

    async function loadToPick() {
        toPick.value = (await apiClient.get('/be/transfer-request/pick/to-pick')).data;
    }

    return {
        createPickModal,
        loadClusters,
        toPick,
        loadToPick,
    };
}
